import HomePage from "../components/home"

export default HomePage
